import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        stack: {
            gap: ['medium.base', 'medium.sm', 'medium.md', 'small.lg'],
        },
        panel: {
            marginTop: remCalc(22),
        },
        accordionItem: {
            margin: 0,
            paddingTop: {base: remCalc(32), md: remCalc(42)},
            paddingBottom: {base: remCalc(32), md: remCalc(22)},
            borderStyle: 'solid',
        },
        item: {
            display: 'flex',
            flexDir: 'row',
            justifyContent: 'space-between',
            padding: 0,
        },
        headerText: {
            color: 'text.default',
            textStyle: 'body-large',
            fontWeight: 'medium',
        },
        headerTextAccordion: {
            color: 'text.default',
            textStyle: 'body-large',
            fontWeight: 'regular',
            cursor: 'pointer',
        },
        text: {
            color: 'text.default',
            textStyle: 'body-small',
            fontWeight: 'regular',
            px: remCalc(16),
        },
        button: {
            borderColor: 'border.light',
            cursor: 'pointer',
        },
        menuItem: {
            paddingInline: 0,
            padding: `${remCalc(8)} ${remCalc(20)} ${remCalc(8)} ${remCalc(5)}`,
            display: 'block',
            float: 'right',
            width: '100%',
        },
        radio: {
            justifyContent: 'space-between',
            flexDirection: 'row-reverse',
            width: '100%',
            borderWidth: remCalc(0.6),
        },
        radioDrawer: {
            cursor: 'pointer',
            borderWidth: remCalc(0.6),
        },
    },
    variants: {
        sortByButton: {
            menuContainer: {
                display: 'flex',
                flexDir: 'column',
                alignItems: 'flex-start',
                padding: 0,
                gap: remCalc(16),
            },
            item: {
                w: '100%',
                h: 'auto',
                alignItems: 'center',
                gap: remCalc(8),
                alignSelf: 'stretch',
            },
            itemIconContainer: {
                w: 'iconsSize.medium',
                h: 'iconsSize.medium',
                justifyContent: 'center',
                alignItems: 'center',
            },
        },
    },
}
